import { ReactNode } from 'react';

type PtacPreferencesFieldProps = {
  label: string;
  hint?: string;
  children: ReactNode;
};

export default function PtacPreferencesField({
  label,
  hint,
  children
}: PtacPreferencesFieldProps) {
  return (
    <div className='flex flex-col items-start gap-1.5'>
      <div className='text-sm font-semibold text-gray-800'>{label}</div>
      {children}
      {hint && <div className='max-w-sm text-xs text-gray-500'>{hint}</div>}
    </div>
  );
}
